import { t } from "@/i18n-js/instance";
import { InputFilterComparator } from "@circle-react-shared/Filter/FilterTypes/InputFilterComparator/InputFilterComparatorV2";
import type { StringComparatorParam } from "@circle-react-shared/Filter/FilterTypes/InputFilterComparator/stringComparators";
import {
  handleStringComparatorApply,
  renderTextSelectedItem,
  stringComparatorsIncludingExistence,
} from "@circle-react-shared/Filter/FilterTypes/InputFilterComparator/stringComparators";
import { Filter } from "@circle-react-shared/FilterV3";
import { useAudienceSearchContext } from "../AudienceSearchContext";

const localeNamespace = "members_directory.header.search.filters";

interface HeadlineFilterProps {
  isInitialOpen?: boolean;
  onApply?: (value: StringComparatorParam | null) => void;
  param: StringComparatorParam;
}

export const HeadlineFilter = ({
  isInitialOpen,
  onApply,
  param,
}: HeadlineFilterProps) => {
  const { isContactsSearch } = useAudienceSearchContext();

  return (
    <Filter onApply={value => handleStringComparatorApply(value, onApply)}>
      <Filter.Chip renderSelectedValue={() => renderTextSelectedItem(param)}>
        {t([localeNamespace, "headline"])}
      </Filter.Chip>

      <Filter.Popover
        title={t([localeNamespace, "headline_title"])}
        isInitialOpen={isInitialOpen}
      >
        <InputFilterComparator
          name="headline"
          param={param}
          placeholder={t([localeNamespace, "headline_placeholder"])}
          comparators={
            isContactsSearch ? stringComparatorsIncludingExistence : undefined
          }
        />
      </Filter.Popover>
    </Filter>
  );
};
